module.exports = __webpack_public_path__ + "static/media/verify-id.08511875.png";